export default __webpack_public_path__ + "static/media/bannerBgMb.f351b6d7.png";